import { FormControl, Box } from "@mui/material";
import RadioSelect from "../radioSelect/RadioSelect";
import { MODALITIES_MAP } from "../../constants/Global";

interface ModalitiesGroupsProps {
  onSelectModality: (modality: string) => void;
  modalitySelected?: string;
  modalityCourt?: string;
  primaryColor: string;
}

const ModalitiesGroups = ({
  onSelectModality,
  modalitySelected,
  primaryColor,
  modalityCourt,
}: ModalitiesGroupsProps) => {
  const availableModalities = modalityCourt
    ? modalityCourt.split(",").map((id) => parseInt(id.trim()))
    : [];

  return (
    <FormControl>
      <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
        {availableModalities.map((id) => {
          const modality = MODALITIES_MAP[id];
          if (!modality) return null;

          return (
            <Box key={id} onClick={() => onSelectModality(String(id))}>
              <RadioSelect
                label={modality.label}
                color={primaryColor}
                icon={modality.icon}
                checked={String(modalitySelected) === String(id)}
              />
            </Box>
          );
        })}
      </Box>
    </FormControl>
  );
};

export default ModalitiesGroups;
